"use client";

import type React from "react";

import { ThemeProvider } from "next-themes";

interface ThemeLayoutWrapperProps {
  children: React.ReactNode;
}

export function ThemeLayoutWrapper({ children }: ThemeLayoutWrapperProps) {
  return (
    <ThemeProvider
      attribute="class"
      defaultTheme="dark"
      themes={["light", "dark", "light-beta", "dark-beta"]}
      enableSystem
      disableTransitionOnChange={true}
    >
      <div className="relative min-h-screen">{children}</div>
    </ThemeProvider>
  );
}
